import React from "react";

const ICON_BG = {
  "bg-blue-50":    "bg-blue-600",
  "bg-amber-50":   "bg-amber-600",
  "bg-emerald-50": "bg-emerald-600",
  "bg-violet-50":  "bg-violet-600",
  "bg-orange-50":  "bg-orange-500",
  "bg-slate-100":  "bg-slate-500",
};

const SourceTypeCard = ({ sourceType, selected, onSelect }) => {
  const { name, description, credentialLabel, available, icon } = sourceType;
  const iconBg = ICON_BG[icon.bgColor] || "bg-text-2";

  return (
    <div
      className={`relative rounded-card transition-all duration-150 flex flex-col ${
        !available
          ? "cursor-not-allowed border border-card-bd bg-card"
          : selected
          ? "border-2 border-primary bg-primary-soft cursor-pointer ring-1 ring-primary/15"
          : "border border-card-bd hover:border-primary cursor-pointer bg-card"
      }`}
      onClick={() => available && onSelect(sourceType)}
      role="button"
      tabIndex={available ? 0 : -1}
      aria-disabled={!available}
      onKeyDown={(e) => {
        if (available && (e.key === "Enter" || e.key === " ")) {
          e.preventDefault();
          onSelect(sourceType);
        }
      }}
    >
      {selected && (
        <div className="absolute top-3.5 right-3.5 w-[22px] h-[22px] rounded-full bg-primary flex items-center justify-center">
          <span className="text-white text-[11px] font-bold leading-none">✓</span>
        </div>
      )}

      <div className={`p-4 pb-0 flex-1 flex flex-col ${!available ? "opacity-35" : ""}`}>
        <div className="flex items-center gap-3 mb-3">
          <div
            className={`w-10 h-10 rounded-lg ${iconBg} flex items-center justify-center text-[14px] font-bold text-white flex-shrink-0`}
          >
            {icon.letter}
          </div>
          <div className="font-semibold text-[13px] text-text leading-snug">{name}</div>
        </div>
        <p className="text-[12px] text-text-2 leading-[1.55] line-clamp-2">{description}</p>
      </div>

      <div className={`px-4 py-3 mt-auto ${!available ? "opacity-35" : ""}`}>
        <div className="border-t border-border pt-2.5">
          {available ? (
            <span className="text-[11px] font-medium text-text-2">
              {credentialLabel}
            </span>
          ) : (
            <span className="inline-flex items-center text-[10px] font-semibold text-text-2 bg-surface-2 px-2 py-0.5 rounded tracking-wider uppercase">
              Coming Soon
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default SourceTypeCard;
